import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'
import { normaliseRecommendations } from 'libs/athos/helpers/normalisers'
import { generateAthosProvider } from 'libs/athos/fetchers/provider'
import { getPersonalizationOrigin } from 'libs/athos/athos-utils'
import type { AthosFetchOptions } from 'libs/athos/athos.types'

export class AthosRecommend extends AthosFetcher {
  generateOrigin() {
    // Recommendations are served from the dedicated Athos P13N cluster,
    // distinct from the standard discovery origin.
    return getPersonalizationOrigin(this.params.siteID)
  }

  generateURL() {
    return super.generateURL('/recommend')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { productId, tags, limit, profile } = options

    if (productId) this.params.set('product', productId)
    if (tags) this.params.set('tags', tags)
    if (limit) this.params.set('limits', limit)
    if (profile) this.params.set('tags', profile)

    this.params.setViewedProducts()
    this.params.setCartItems()
    this.params.setShopperID()

    super.updateParams()
  }
}

/**
 * The recommend response is an array of profile objects:
 *   [{ responseId, results, profile }]
 * Results across all returned profiles are flattened for rendering, while the
 * top-level `responseId` and `profile` are preserved for Beacon 2.0 tracking.
 */
export const AthosRecommendProvider = generateAthosProvider(AthosRecommend, async (_results) => {
  const profiles = Array.isArray(_results) ? _results : [_results]

  const promises = profiles.map(res => normaliseRecommendations(res))
  const resolvedResults = await Promise.all(promises)
  const results = resolvedResults.flat()

  const [firstProfile] = profiles
  return {
    results,
    responseId: firstProfile?.responseId,
    profile: firstProfile?.profile
  }
})
